import { useState, useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  useDataProvider,
  useNotify,
  useRedirect,
} from 'react-admin';
import { Box } from '@mui/material';
import { PermissionCheckboxGroup } from '../../components/settings/PermissionCheckboxGroup';

interface Permission {
  id: number;
  name: string;
  description?: string;
  category?: string;
}

const PermissionInput = ({ source }: { source: string }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [allPermissions, setAllPermissions] = useState<Permission[]>([]);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  useEffect(() => {
    // Fetch all permissions
    dataProvider
      .getList('permissions', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'name', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setAllPermissions(data as Permission[]);
      })
      .catch((error) => {
        notify(`Error loading permissions: ${error.message}`, { type: 'error' });
      });
  }, [dataProvider, notify]);

  return (
    <Box sx={{ mt: 2 }}>
      <input type="hidden" name={source} value={JSON.stringify(selectedIds)} />
      <PermissionCheckboxGroup
        permissions={allPermissions}
        selectedIds={selectedIds}
        onChange={setSelectedIds}
      />
    </Box>
  );
};

export const RoleCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify('Role created successfully');
    redirect('list', 'roles');
  };

  return (
    <Create mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <TextInput source="name" validate={required()} fullWidth />
        <TextInput
          source="description"
          multiline
          rows={3}
          fullWidth
        />
        <PermissionInput source="permission_ids" />
      </SimpleForm>
    </Create>
  );
};
